//@flow

export const percentOfTotal = (total: ?number, cost: ?number): string => {
  if (!total || !cost) return "0.0%";
  return `${parseFloat((cost / total + 0.00001) * 100).toFixed(1)}%`;
};

export const convertDecimal = (value: ?number) => {
  return `${parseFloat(value).toFixed(4)}`;
};

export const varianceCost = (actual: ?number, target: ?number, flag: ?string) => {
  if ((flag === 'FOB' && !target) || (target === "" && !target)) return "-";
  if (typeof actual === "undefined" || actual === null) return "-";
  return `$${parseFloat(actual - target)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+\b)/g, ",")
    .replace(/-(.*)/, "($1)")}`;
};

export const varianceMinutes = (actual: ?number, target: ?number) => {
  if (target === "" && !target) return "-";
  if (typeof actual === "undefined" || actual === null) return "-";
  return `${parseFloat(actual - target)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+\b)/g, ",")
    .replace(/-(.*)/, "($1)")}`;
};

export const styleClass = (actual: ?number, target: ?number): string => {
  if (target === "" && !target) return { color: "black" };
  if (typeof actual === "undefined" || actual === null) return { color: "black" };
  if (actual > target && parseFloat((actual - target).toFixed(2)) !== 0) return { color: "red" };
  else if (parseFloat((actual - target).toFixed(2)) === 0) return { color: "green" };
  else return { color: "green" };
};

export const convertDecimal2 = (value: ?number) => {
  return `$${parseFloat(value).toFixed(2)}`;
};
export const convertDecimalMin = value => {
  if(typeof value === "number"){
      let multiplicator = Math.pow(10, 2);
      value = parseFloat((value * multiplicator).toFixed(2));
      let val =(Math.round(value) / multiplicator);
      return val.toFixed(2);
    } else {
      return 0.00;
    }
};
export const percentOfTotalNotFixed = (total: number, cost: number): string =>
  `${parseFloat(cost / total * 100)}%`;

export const sumByProperty = (arrayOfObjects: Array<Object>, propertyToSumBy: string): number => {
  if (!arrayOfObjects || arrayOfObjects.length === 0) return 0;
  return arrayOfObjects.reduce((sum, item) => {
    if (item && typeof item[propertyToSumBy] === "number") return sum + item[propertyToSumBy];
    else return sum;
  }, 0);
};

export const sumFlyknitByProperty = (
  arrayOfObjects: Array<Object>,
  propertyToSumBy: string
): number => {
  if (!arrayOfObjects || arrayOfObjects.length === 0) return 0;
  return arrayOfObjects.reduce((sum, item) => {
    if (
      item &&
      typeof item[propertyToSumBy] === "number" &&
      item.costsheetMaterialProfitExclusionIndicator
    )
      return sum + item[propertyToSumBy];
    else return sum;
  }, 0);
};
export const sumByPropertyString = (
  arrayOfObjects: Array<Object>,
  propertyToSumBy: string
): number => {
  if (!arrayOfObjects || arrayOfObjects.length === 0) return 0;
  return arrayOfObjects.reduce((sum, item) => {
    if (item && item.detail !== "Total") return sum + Number(item[propertyToSumBy]);
    else return sum;
  }, 0);
};

export const numberToFixed = (value: ?number, fixedNum: number): string => {
  if (fixedNum === undefined) {
    fixedNum = 0;
  }
  if(typeof value === "number"){
    let multiplicator = Math.pow(10, fixedNum);
    value = parseFloat((value * multiplicator).toFixed(fixedNum));
    let val =(Math.round(value) / multiplicator);
    return val.toFixed(fixedNum);
  } else {
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/helpers.js